import { createTheme } from "@mui/material/styles";
import "@fontsource-variable/montserrat";

const theme = createTheme({
    typography: {
        fontFamily: "Montserrat Variable",
        button: {
            textTransform: 'none'
        }
    },
    palette: {
        primary: {
            main: "#ff9031",
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 2000,
        },
    },
});


export default theme;
